var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-acb9e993-2b18-4374-9dd4-b6dfef402456",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.5 227.5",
    style: {
      enableBackground: "new 0 0 205.5 227.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,145.5h0.8c11.8,0,21.3-9.5,21.3-21.3V81.7c0-11.8-9.5-21.3-21.3-21.3h-0.8c-11.8,0-21.3,9.5-21.3,21.3 v42.6C81.2,136,90.8,145.5,102.5,145.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.9,145.5h0.8c11.8,0,21.3-9.5,21.3-21.3V48.6c0-11.8-9.5-21.3-21.3-21.3h-0.8c-11.8,0-21.3,9.5-21.3,21.3 v75.6C137.6,136,147.1,145.5,158.9,145.5L158.9,145.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.5,156.9H67.9V48.6c0-11.8-9.5-21.3-21.3-21.3h-0.8c-11.8,0-21.3,9.5-21.3,21.3v130.3 c0,11.8,9.5,21.3,21.3,21.3h113.6c11.8,0,21.3-9.5,21.3-21.3v-0.8C180.7,166.4,171.2,156.9,159.5,156.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff96d51348cc7038b06a132c92e33241.svg";
export { ForwardRef as ReactComponent };